import { render } from "./CategoryChanger.vue?vue&type=template&id=18ab2721&scoped=true"
import script from "./CategoryChanger.vue?vue&type=script&lang=js"
export * from "./CategoryChanger.vue?vue&type=script&lang=js"

import "./CategoryChanger.vue?vue&type=style&index=0&id=18ab2721&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ab2721"]])

export default __exports__